import jwtWorker from 'utils/jwt-worker';

export const INTERVENTION_SOCKET_STATUS = {
    UPDATED_INTERVENTION_STATUS: "update_intervention",
    NEW_INTERVENTION_STATUS: "new_intervention",
    REMOVED_INTERVENTION_STATUS: "remove_intervention",
    UPDATED_LAST_SEEN: "update_last_seen_intervention"
}

export const INTERVENTION_STATUS = {
    ACCEPTED: "accepted",
    COMPLETED: "completed",
    INITIATED: "init",
    IN_PROGRESS: "in_progress",
    DEFFERRED: "deferred",
    TRANSFERRED: "transferred",
    ARCHIVED: "archived",
    ABORTED: "aborted"
}

export const INTERVENTION_STEP = {
    TRANSFERED_STEP: "async_transfer"
}

export const MESSAGE_DIRECTION = {
    INCOMING: "incoming",
    OUTGOING: "outgoing"
}

//BASIC ROUTE PREFIXES
export const BASE_ROUTES = {
    FOLDERS_ROUTE: "/folders",
    TASKS_ROUTE: "/tasks",
    ANALYTICS_ROUTE: "/analytics",
    SUPERVISION_ROUTE: "/supervisor",
    ADMIN_ROUTE: "/admin",
    ACCESS_DENIED: "/access-denied",
    LOGIN: "/login",
    PASSWORD_FIRST_LOGIN: "/password-first-login",
    CHANGE_PASSWORD: "/change-password",
    FORGOT_PASSWORD: "/forgot-password",
    RESET_PASSWORD: "/reset-password"
}

export const ROLES = {
    ADMIN: "admin",
    AGENT: "agent",
    SUPERVISOR: "supervisor",
    ANALYST: "analyst"
}

export const AGENT_STATUS = [
    {
        STATUS_ID: -1,
        FLAT_COLOR: "#ebebeb",
        TXT_COLOR: "#343a40",
        NESTED_COLOR: "#a5a5a5",
        ICON: "bi bi-x-circle",
        LABEL: "Hors Ligne",
    },
    {
        STATUS_ID: 0,
        COLOR: "#28A745",
        LABEL: "All Status"
    },
    {
        STATUS_ID: 1,
        COLOR: "#28A745",
        ICON: "bi bi-check-circle-fill",
    },
    {
        STATUS_ID: 2,
        COLOR: "#78ef20",
        ICON: "bi bi-circle-fill",
        FLAT_COLOR: "#28A745",
    },
    {
        STATUS_ID: 3,
        COLOR: "#78ef20",
        ICON: "bi bi-dash-circle-fill",
        FLAT_COLOR: "#28A745",
    },
    {
        STATUS_ID: 4,
        COLOR: "#fdb913",
        ICON: "bi bi-exclamation-circle-fill",
        FLAT_COLOR: "#ffc107"
    },
    {
        STATUS_ID: 5,
        COLOR: "#d74654",
        ICON: "bi bi-clock-fill",
        FLAT_COLOR: "#C6303E"
    }
]

export const CUSTOM_MESSAGES = {
    INVALID_RANGE_DATES: "Start date should be before end date",
    ACCESS_DENIED_MESSAGE: "You don't have access privileges, please contact your administrator",
    CHENAGE_PASSWORD_WIEW_TITLE: jwtWorker.isUserLogged() ? "Change password" : "Please, Change your password",
    SMTHG_WRONG_MESSAGE: "Oops... something went wrong!",
    NO_CHANGES_ISSUED: "No changes has been issued",
    NO_ITEM_SELECTED: "No item has been selected !",
    ACTION_DENIED_4LDAP_USERS: "LDAP users are not eligible for this feature!",
    SUCCESS_DOWNLOAD_MESSAGE: "Report has been downloaded successfully",
    DELETE_ITEM_CONFIRMATION_MESSAGE: "Are you sure to delete this item ?",
    PWD_CHANGED_SUCCESSFULLY: "Your password has been successfully changed"
}

export const SORT_VALUES = {
    ASECENDANT: { label: "Ascending order", value: "ASC" },
    DESCENDANT: { label: "Descending order", value: "DESC" },
}

export const ANALYTICS_PANEL_ITEMS = {
    FLUX_ACTIVITY: "/flux-activity",
    AGENT_ACTIVITY: "/agent-activity",
    QUALITY: "/quality"
}

export const REPORTING_ENDPOINTS_SUFFIXES = {
    ACTIVITY_INTERVENTION: "intervention-activity-report",
    ACTIVITY_CLIENTS: "intervention-client-activity-report",
    ACTIVITY_DAILY_INTERVENTION: "intervention-daily-activity-report",
    ACTIVITY_INTERVENTION_TAGS: "tags-categorization-report",
    ACTIVITY_AGENT: "agent-activity-report",
    QUALITY_INTERVENTION_DELAY: "intervention-processing-delay-report",
}

export const SUPERVISION_SYNC_DELAY_OPTIONS = [
    { key: '30000', label: '30 s' },
    { key: '60000', label: '1 min' },
    { key: '300000', label: '5 min' },
    { key: '600000', label: '10 min' }
]

export const ATTACHMENT_TYPES = {
    FILE: "file",
    IMAGE: "image",
    AUDIO: "audio",
    VIDEO: "video",
    FALLBACK: "fallback",
    LOCATION: "location"
}

export const INNER_CONTAINER_HEIGHT = window.innerHeight - 165;